import { render, staticRenderFns } from "./APSaleDetailForReturn.vue?vue&type=template&id=9163162a&"
import script from "./APSaleDetailForReturn.vue?vue&type=script&lang=js&"
export * from "./APSaleDetailForReturn.vue?vue&type=script&lang=js&"
import style0 from "./APSaleDetailForReturn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "APSaleDetailForReturn.vue"
export default component.exports